import { Outlet, useLocation } from "react-router-dom";
import { classNames } from "primereact/utils";
import Footer from "../../components/footer/Footer.component";
import Header from "../../components/header/Header.component";
import { ResponsiveService } from "../../services/responsive/responsive.service";
import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { useEffect } from "react";
import { MatomoAction, MatomoCategory } from "../../models/matomo.model";
import { MatomoService } from "../../services/matomo/matomo.service";
import { ThemeService } from "../../services/theme/ThemeService.service";

const Main = () => {
	const location = useLocation();
	const matomo = useMatomo();

	/**
	 * MATOMO: login event
	 * Send the login event, once the user is authenticated, and the matomo instance has been created
	 */

	useEffect(() => {
		MatomoService.getLoginEvent().subscribe((ev) => {
			if (ev) {
				matomo.trackEvent({
					category: MatomoCategory.AUTHENTICATION,
					action: MatomoAction.LOGIN,
				});
			}
		});
		/**
		 * Theme:
		 * Now that the user has logged in, update the theme based on his brand identity
		 */
		ThemeService.setTheme();
	}, []);

	/**
	 * MATOMO: track page views
	 * Keep track of every page visited
	 */

	useEffect(() => {
		matomo.trackPageView();
	}, [location]);

	return (
		<div
			className={classNames("layout-container", ResponsiveService.isMobile() && "responsive")}
		>
			{/* Menu:  */}
			<Header />

			<main className="layout-content">
				<Outlet />
			</main>

			<Footer />
		</div>
	);
};

export default Main;
